import localConfig from 'mode-shared/configs/config';
import { QueryKeys } from 'mode-shared/constants/queryKeys';
import { contentfulClient } from 'mode-shared/utils';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { SynthDiscordLinkSkeleton } from '../types';

const fetchSynthDiscordLink = async () => {
  try {
    let content = [];

    if (localConfig.showContentLive) {
      content = (
        await contentfulClient.getEntries<SynthDiscordLinkSkeleton>({
          content_type: 'synthDiscordLink',
          limit: 1000,
        })
      ).items;
    } else {
      content = (
        await axios.get<void, AxiosResponse<SynthDiscordLinkSkeleton[]>>(
          `${localConfig.contentfulUrl}/synthDiscordLink.json`
        )
      ).data;
    }
    return content.length > 0 ? content.map((item) => item.fields.url)[0] : '';
  } catch (e) {
    console.error(e);
    return;
  }
};

export const useSynthDiscordLink = (options = {}) => {
  return useQuery({
    queryKey: [QueryKeys.SYNTH_DISCORD_LINK],
    queryFn: fetchSynthDiscordLink,
    refetchOnWindowFocus: localConfig.showContentLive,
    ...options,
  });
};
